export default "__VITE_ASSET__CAr7D9SK__"